import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { getListUnderLevelStaff } from "../../pages/edit-form/api-endpoint/callApi";
import {
  AdministrationColumns,
  BusinessActivityColumns,
  CorporateLegalColumns,
  EndUserColumns,
} from "../../shared/Components/Columns";
import { selectUserProfile, selectUserRole } from "../../store/auth/selector";

export const useProfileColumns = () => {
  const profile = useSelector(selectUserProfile);
  const profileRole = useSelector(selectUserRole);
  const [binusianUnderLevel, setBinusianUnderLevel] = useState<string[]>([]);

  useEffect(() => {
    const loadUnderLevelStaff = async () => {
      try {
        const staffList = await getListUnderLevelStaff(profile.BinusianId);
        setBinusianUnderLevel(staffList);
      } catch (error) {
        console.error(error);
      }
    };
    loadUnderLevelStaff();
  }, [profile.BinusianId]);

  const columns = (() => {
    switch (profileRole.roleId) {
      case "RL230000002":
        return EndUserColumns({ profileRole });
      case "RL230000003":
        return CorporateLegalColumns({
          profile,
          profileRole,
          binusianUnderLevel,
        });
      case "RL230000004":
        // return LegalRelationColumns({
        //   profile,
        //   profileRole,
        //   binusianUnderLevel,
        // });
        return AdministrationColumns({ profile, binusianUnderLevel });
      case "RL240000001":
        return BusinessActivityColumns({ profile, profileRole });
      default:
        return AdministrationColumns({ profile, binusianUnderLevel });
    }
  })();

  return { columns, profile, profileRole, binusianUnderLevel };
};
